// extracted by mini-css-extract-plugin
export default {"behaviorAndScopeInfo":"Confirmation_behaviorAndScopeInfo__0xKkZ","exclusionInfo":"Confirmation_exclusionInfo__kaKqa","exclusionNumber":"Confirmation_exclusionNumber__YhEW6"};